(() => {
  'use strict';
  const api = window.FabienneNativeCart;
  if (!api || !window.fetch) return;
  const i18n = JSON.parse(document.getElementById('FabienneTranslations')?.textContent || '{}');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: document.documentElement.dataset.currency || 'EUR' }).format(cents / 100);
  const bind = root => root.querySelectorAll('[data-native-pairing]:not([data-pairing-bound])').forEach(offer => {
    offer.dataset.pairingBound = 'true';
    const scope = offer.closest('.native-product');
    const variant = scope.querySelector('[data-native-variant]'), quantity = scope.querySelector('input[name=quantity]');
    const button = offer.querySelector('[data-native-pairing-add]'), label = offer.querySelector('[data-pairing-label]');
    let adding = false;
    function update() {
      const qty = Number(quantity.value), option = variant.selectedOptions[0];
      button.disabled = adding || !Number.isInteger(qty) || qty < 1 || qty > 99 || option.dataset.available !== 'true';
      label.textContent = i18n.addPairing + ' — ' + money(Number(option.dataset.cents) * (Number.isFinite(qty) ? qty : 1) + Number(offer.dataset.companionCents));
    }
    button.hidden = false;
    variant.addEventListener('change', update);
    quantity.addEventListener('input', update);
    quantity.addEventListener('change', update);
    update();
    button.addEventListener('click', async () => {
      if (adding || button.disabled) return;
      const qty = Number(quantity.value);
      if (!Number.isInteger(qty) || qty < 1 || qty > 99 || variant.selectedOptions[0].dataset.available !== 'true') return;
      adding = true;
      const controls = [...scope.querySelectorAll('button, input, select')].map(control => ({ control, disabled: control.disabled }));
      controls.forEach(({ control }) => control.disabled = true);
      button.setAttribute('aria-busy', 'true');
      label.textContent = i18n.adding;
      try {
        const response = await fetch(api.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant.value), quantity: qty }, { id: Number(offer.dataset.companionVariant), quantity: 1 }] }) });
        const result = await response.json();
        if (!response.ok) throw Object.assign(new Error(), { publicMessage: typeof result.description === 'string' ? result.description : i18n.addError });
        window.location.assign(api.root + 'cart');
      } catch (error) {
        adding = false;
        controls.forEach(({ control, disabled }) => control.disabled = disabled);
        button.removeAttribute('aria-busy');
        update();
        api.notify(error.publicMessage || i18n.addError, true, true);
      }
    });
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
